import React, { useEffect, useState } from 'react';
import { getAdminLanguage } from '../i18n';

// Operations는 공개 상태만 제공한다. 어드민 세션/권한과 점검 Controller는 건드리지 않는다.
const URL = process.env.REACT_APP_OPERATIONS_PUBLIC_MAINTENANCE_URL || '/ops-public/maintenance';
const PROFILE = String(process.env.REACT_APP_OPERATIONS_PROFILE || (process.env.NODE_ENV === 'production' ? 'PRODUCTION' : 'LOCAL')).toUpperCase();
const TEXT = {
  en: ['System maintenance', 'The administration interface is temporarily unavailable.', 'Service is expected to resume at'],
  ko: ['서버 점검 중', '점검 시간 동안 어드민 클라이언트를 이용할 수 없습니다.', '서비스 재개 예정'],
  ru: ['Техническое обслуживание', 'Панель администратора временно недоступна.', 'Ожидаемое возобновление'],
  zh: ['服务器维护中', '管理界面暂时无法使用。', '预计恢复'],
  vi: ['Đang bảo trì hệ thống', 'Giao diện quản trị tạm thời không khả dụng.', 'Dự kiến mở lại'],
  th: ['ระบบกำลังบำรุงรักษา', 'หน้าแอดมินไม่พร้อมใช้งานชั่วคราว', 'คาดว่าจะเปิดอีกครั้ง'],
  ja: ['サーバーメンテナンス中', '管理画面は一時的にご利用いただけません。', '再開予定'],
  it: ['Manutenzione del sistema', 'L’interfaccia amministrativa non è temporaneamente disponibile.', 'Ripresa prevista'],
  fr: ['Maintenance du système', 'L’interface administrateur est temporairement indisponible.', 'Reprise prévue'],
  hi: ['सिस्टम रखरखाव', 'व्यवस्थापक इंटरफ़ेस अस्थायी रूप से उपलब्ध नहीं है।', 'अनुमानित पुनः आरंभ'],
  ur: ['سسٹم کی دیکھ بھال', 'ایڈمن انٹرفیس عارضی طور پر دستیاب نہیں۔', 'متوقع بحالی'],
  es: ['Mantenimiento del sistema', 'La interfaz de administración no está disponible temporalmente.', 'Reanudación prevista'],
};

function isActive(snapshot, now) {
  const plan = snapshot?.plan;
  if (Number(plan?.workflowVersion) !== 2 || ['COMPLETED','CANCELLED'].includes(plan?.status)) return false;
  const start = Date.parse(plan.startsAt || '');
  return snapshot.active || Number.isFinite(start) && now >= start;
}

export default function AdminMaintenanceGate({ children }) {
  const [snapshot, setSnapshot] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('npc:admin-maintenance') || 'null'); } catch (_) { return null; }
  });
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    let stopped = false;
    async function refresh() {
      try {
        const sep = URL.includes('?') ? '&' : '?';
        const response = await fetch(`${URL}${sep}profile=${encodeURIComponent(PROFILE)}`, {
          cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`maintenance status ${response.status}`);
        const value = await response.json();
        value.fetchedLocalAt = Date.now();
        if (stopped) return;
        setSnapshot(value);
        try { sessionStorage.setItem('npc:admin-maintenance', JSON.stringify(value)); } catch (_) {}
      } catch (_) { /* 네트워크 단절 시 이전 ACTIVE 상태를 유지한다. */ }
    }
    void refresh();
    const timer = setInterval(() => { setNow(Date.now()); void refresh(); }, 2000);
    const onFocus = () => { void refresh(); };
    window.addEventListener('focus', onFocus);
    return () => { stopped = true; clearInterval(timer); window.removeEventListener('focus', onFocus); };
  }, []);
  const offset = Number(snapshot?.controllerTime || 0) - Number(snapshot?.fetchedLocalAt || snapshot?.controllerTime || 0);
  if (!isActive(snapshot, now + (Number.isFinite(offset) ? offset : 0))) return children;
  const [title, desc, resume] = TEXT[getAdminLanguage()] || TEXT.en;
  const endMs = Date.parse(snapshot.plan?.expectedEndAt || '');
  return (
    <main role="alert" style={{ minHeight: '100vh', background: '#0c0d12', color: '#fff', display: 'grid',
      placeItems: 'center', padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <section style={{ background: '#171923', border: '1px solid #434856', borderRadius: 22,
        padding: '48px 36px', width: 'min(92vw, 680px)', textAlign: 'center', boxShadow: '0 25px 70px #0008' }}>
        <div style={{ color: '#ffc247', fontSize: 15, letterSpacing: 3, fontWeight: 700 }}>NIGHT POKER BUSINESS</div>
        <h1 style={{ fontSize: 32, margin: '30px 0 14px' }}>{title}</h1>
        <p style={{ fontSize: 18, color: '#d2d7e2', lineHeight: 1.7 }}>{desc}</p>
        <p style={{ marginTop: 25, color: '#ffc247' }}>{resume}: {' '}
          {Number.isFinite(endMs) ? new Date(endMs).toLocaleString() : '-'}</p>
      </section>
    </main>
  );
}
